export default __webpack_public_path__ + "static/media/womensRights.2ef4594c.webp";